import { Injectable } from "@angular/core";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { SecuritySystem, SecuritySystemData, SecuritySystemHelper } from "../model";

@Injectable({
    providedIn: "root",
})
export class SecuritySystemDbService {
    helper = new SecuritySystemHelper();
    wsHelper: ClareWSCrudHelperService<SecuritySystem, SecuritySystemData>;

    constructor(private tsLoggingService: TSLoggingService, private crudHelper: DbCrudHelper) {
        this.wsHelper = new ClareWSCrudHelperService(this.tsLoggingService, this.crudHelper, this.helper);
    }

    getSecuritySystemById(id: number) {
        return this.wsHelper.retrieveSingle({
            endpoint: "GetSecuritysystem",
            data: {
                id,
            },
        });
    }

    updateSystem(securitysystem: SecuritySystem) {
        return this.wsHelper.update({
            endpoint: "UpdateSecuritysystem",
            data: securitysystem,
            logData: {
                securitysystem,
            },
        });
    }

    getSecuritysystemsByMacAddresses(macAddresses: string[]) {
        return this.wsHelper.retrieve({
            endpoint: "GetProjectAndRelatedByMacAddresses",
            data: {
                mac_addresses: macAddresses,
            },
        });
    }
}
